export const angleData = [
    {
        radians:['','6'],
        degrees:'30',
        sin:'\\frac{\\sqrt{3}}{2}',
        cos:'\\frac{1}{2}'
    },

    {
        radians:['','4'],
        degrees:'45',
        sin:'\\frac{\\sqrt{2}}{2}',
        cos:'\\frac{\\sqrt{2}}{2}'
    },

    {
        radians:['','3'],
        degrees:'60',
        sin:'\\frac{1}{2}',
        cos:'\\frac{\\sqrt{3}}{2}'
    },

    {
        radians:['2','3'],
        degrees:'120',
        sin:'\\frac{-1}{2}',
        cos:'\\frac{\\sqrt{3}}{2}'
    },

    {
        radians:['3','4'],
        degrees:'135',
        sin:'\\frac{-\\sqrt{2}}{2}',
        cos:'\\frac{\\sqrt{2}}{2}'
    },

    {
        radians:['5','6'],
        degrees:'150',
        sin:'\\frac{-\\sqrt{3}}{2}',
        cos:'\\frac{1}{2}'
    },

    {
        radians:['7','6'],
        degrees:'210',
        sin:'\\frac{-\\sqrt{3}}{2}',
        cos:'\\frac{-1}{2}'
    },

    {
        radians:['5','4'],
        degrees:'225',
        sin:'\\frac{-\\sqrt{2}}{2}',
        cos:'\\frac{-\\sqrt{2}}{2}'
    },

    {
        radians:['4','3'],
        degrees:'240',
        sin:'\\frac{-1}{2}',
        cos:'\\frac{-\\sqrt{3}}{2}'
    },

    {
        radians:['5','3'],
        degrees:'300',
        sin:'\\frac{1}{2}',
        cos:'\\frac{-\\sqrt{3}}{2}'
    },
    {
        radians:['7','4'],
        degrees:'315',
        sin:'\\frac{\\sqrt{2}}{2}',
        cos:'\\frac{-\\sqrt{2}}{2}'
    },

    {
        radians:['11','6'],
        degrees:'330',
        sin:'\\frac{\\sqrt{3}}{2}',
        cos:'\\frac{-1}{2}'
    },
]
// \\frac{\\pi}{2}`
// `\\frac{\\sqrt{3}}{2}`